import React, { useContext } from 'react'

const NonSortableHeaderCell = ({ cell, value, cellIndex }) => (
  <div className="text-dark w-100 d-block font-weight-bold">
    { value }
  </div>
)

export default NonSortableHeaderCell
